import { useEffect, useState } from "react";
import { BACKEND_CONFIGURED, api, fmtTime, isBackendNotConfigured } from "@/api";
import { ResultBadge } from "@/components/ResultBadge";
import { directionLabel, entrySourceLabel, marketTypeLabel, qualityLabel, resultLabel, sourceLabel } from "@/i18n";

const sources = [
  ["", "全部号机"], ["gauls", sourceLabel("gauls")], ["unknown", sourceLabel("unknown")],
];
const results = ["", "FULL_WIN", "PARTIAL_WIN", "PARTIAL_WIN_THEN_BE",
  "MANUAL_PROFIT_CLOSE", "BREAKEVEN", "LOSS", "MANUAL_LOSS_CLOSE",
  "CANCELLED", "NOT_TRIGGERED", "OPEN", "AMBIGUOUS", "UNVERIFIED"];

export default function TradeHistoryPage() {
  const [filters, setFilters] = useState({ source: "", symbol: "", result: "", date_from: "", date_to: "" });
  const [query, setQuery] = useState({});
  const [rows, setRows] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    if (!BACKEND_CONFIGURED) {
      setRows([]);
      setError("后端尚未部署，交易历史暂时没有真实数据。");
      return () => { active = false; };
    }

    api.get("/trade-history", { params: query }).then((response) => {
      if (!active) return;
      const items = Array.isArray(response?.data?.items) ? response.data.items : [];
      setRows(items);
      setError(Array.isArray(response?.data?.items) ? "" : "交易历史接口返回格式异常");
    }).catch((err) => {
      if (!active) return;
      setRows([]);
      setError(isBackendNotConfigured(err) ? "后端尚未部署，交易历史暂时没有真实数据。" : "交易历史加载失败");
    });

    return () => { active = false; };
  }, [query]);

  const update = (key) => (event) => setFilters({ ...filters, [key]: event.target.value });
  const apply = () => setQuery(Object.fromEntries(Object.entries(filters).filter(([, value]) => value)));
  const reset = () => { setFilters({ source: "", symbol: "", result: "", date_from: "", date_to: "" }); setQuery({}); };

  return (
    <section data-testid="trade-history-page">
      <div className="page-heading"><div><p className="eyebrow">交易审计账本</p><h1>交易历史</h1></div></div>
      <div className="filter-bar" data-testid="trade-history-filters">
        <label>号机<select value={filters.source} onChange={update("source")} data-testid="filter-source-select">
          {sources.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
        </select></label>
        <label>币种<input value={filters.symbol} onChange={update("symbol")} placeholder="BTC" data-testid="filter-symbol-input" /></label>
        <label>结果<select value={filters.result} onChange={update("result")} data-testid="filter-result-select">
          {results.map((value) => <option key={value} value={value}>{value ? resultLabel(value) : "全部结果"}</option>)}
        </select></label>
        <label>开始日期<input type="text" inputMode="numeric" placeholder="年-月-日，例如 2026-08-25" value={filters.date_from} onChange={update("date_from")} data-testid="filter-date-from-input" /></label>
        <label>结束日期<input type="text" inputMode="numeric" placeholder="年-月-日，例如 2026-08-25" value={filters.date_to} onChange={update("date_to")} data-testid="filter-date-to-input" /></label>
        <div className="filter-actions"><button onClick={apply} data-testid="apply-filters-button">筛选</button><button className="secondary" onClick={reset} data-testid="reset-filters-button">重置</button></div>
      </div>
      {error && <p className="error-text" data-testid="trade-history-error">{error}</p>}
      <div className="table-frame wide"><table data-testid="trade-history-table"><thead><tr>
        <th>号机（真实 KOL）</th><th>币种</th><th>市场类型</th><th>方向</th><th>入场</th><th>入场来源</th>
        <th>止损</th><th>止盈</th><th>开仓时间</th><th>平仓时间</th><th>KOL 报告结果</th><th>市场验证结果</th><th>R 收益</th><th>验证质量</th>
      </tr></thead><tbody>{rows.map((row, index) => {
        const tradeId = String(row?.trade_id || `row-${index}`);
        return <tr key={tradeId} data-testid={`trade-row-${tradeId}`}>
          <td className="source-name">{sourceLabel(row?.source, row?.source_display)}</td><td className="mono">{row?.symbol || "—"}</td>
          <td>{marketTypeLabel(row?.market_type)}</td><td>{directionLabel(row?.direction)}</td><td className="mono">{row?.entry || "—"}</td>
          <td>{entrySourceLabel(row?.entry_source)}</td><td className="mono">{row?.stop_loss || "—"}</td>
          <td className="mono">{Array.isArray(row?.take_profits) && row.take_profits.length ? row.take_profits.join(" / ") : "—"}</td><td className="mono">{fmtTime(row?.open_time)}</td>
          <td className="mono">{fmtTime(row?.close_time)}</td><td><ResultBadge value={row?.reported_result} testId={`reported-${tradeId}`} /></td>
          <td><ResultBadge value={row?.verified_result} testId={`verified-${tradeId}`} /></td>
          <td className="mono">{row?.realized_r === null || row?.realized_r === undefined ? "—" : `${row.realized_r}R`}</td><td>{qualityLabel(row?.verification_quality)}</td>
        </tr>;
      })}</tbody></table></div>
      {!rows.length && !error && <p className="empty-state" data-testid="trade-history-empty">从功能启用后的新信号开始记录。</p>}
    </section>
  );
}
